module.exports = __webpack_public_path__ + "static/media/20_000017.f1286c97.jpg";